import script from "./AssinaturaCompartilhadaFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./AssinaturaCompartilhadaFormView.vue?vue&type=script&setup=true&lang=js"

import "./AssinaturaCompartilhadaFormView.vue?vue&type=style&index=0&id=57e4c798&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57e4c798"]])

export default __exports__